import {GaEntityType} from '@optimaxdev/analytics/dist/types/types';
import {createGAEvent, pushDataLayer} from '@optimaxdev/analytics/mobile';
import {pickBy} from 'ramda';

export type LabelType = string | {[key: string]: string} | undefined | null;

/**
 * Send analytics
 * @param {GaEntityType} event - event for sending analytics
 * @param {LabelType} label - data value for send analytics
 * @param {string} type - glasses type
 */
export const sendAnalytics = (event: GaEntityType, label?: LabelType, type?: string) => {
    const typeName = type && type[0].toUpperCase() + type.substring(1, 3);
    const dataValue = {
        version: 'M',
        type: typeName || '',
    };
    const clearEmptyValue = (val: string) => Boolean(val);

    if (label) {
        const dataLabel =
            typeof label === 'string'
                ? {
                      label,
                  }
                : {
                      ...label,
                  };

        Object.assign(dataValue, dataLabel);
    }

    pushDataLayer(createGAEvent(event, pickBy(clearEmptyValue, dataValue)));
};
